import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "language-switch" }

import { ref, computed } from 'vue'
import { NSelect } from 'naive-ui'
import { useI18n } from 'vue-i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'LanguageSwitch',
  setup(__props) {

const { t } = useI18n()
const i18n = useI18n()

const language = ref(i18n.locale)
const availableLocales = computed(() => [
  { label: t('app.language.zhs'), value: 'zhs' },
  { label: t('app.language.zht'), value: 'zht' },
  { label: t('app.language.nl'), value: 'nl' },
  {
    label:
      language.value === 'en'
        ? t('app.language.en')
        : `${t('app.language.en')} (English)`,
    value: 'en',
  },
  { label: t('app.language.fr'), value: 'fr' },
  { label: t('app.language.de'), value: 'de' },
  { label: t('app.language.it'), value: 'it' },
  { label: t('app.language.ja'), value: 'ja' },
  { label: t('app.language.pt'), value: 'pt' },
  { label: t('app.language.ptb'), value: 'ptb' },
  { label: t('app.language.es'), value: 'es' },
])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(NSelect), {
      value: language.value,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((language).value = $event)),
      placeholder: _unref(t)('app.language.index'),
      options: availableLocales.value
    }, null, 8, ["value", "placeholder", "options"])
  ]))
}
}

})